exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container{margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px}@media (min-width:1200px){.container{width:1170px;max-width:unset}}.container.overflow{overflow:auto}html{overflow-y:auto}.is-top{align-self:flex-start}.grab-bing{cursor:-o-grab;cursor:grab}.grab-bing:active{cursor:-o-grabbing;cursor:grabbing}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-28bdc349","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./vue-source/src/App.vue
// module id = 173
// module chunks = 0